export const POSPeriodMappedRemapping = [
  {
    key: 'date',
    attributeName: 'Date',
    external: 'Date',
    internal: null,
    apiEndPoint: null,
    dependsOn: [],
    apiDependsOn: [],
    value: null,
    isDisabled: false,
    isLoading: false,
    option: [],
    showDropdown: true
  },
  {
    key: 'week-commencing',
    attributeName: 'Week Commencing',
    external: 'WeekCommencing',
    internal: null,
    apiEndPoint: null,
    dependsOn: [],
    apiDependsOn: [],
    value: null,
    isDisabled: false,
    isLoading: false,
    option: [],
    showDropdown: true
  },
  {
    key: 'periodicity',
    attributeName: 'Periodicity',
    external: null,
    internal: 'Periodicity',
    apiEndPoint: 'periodicity',
    dependsOn: [],
    apiDependsOn: [],
    value: null,
    isDisabled: false,
    isLoading: false,
    option: [],
    showDropdown: true
  },
  {
    key: 'period-start-date',
    attributeName: 'Period Start Date',
    external: null,
    internal: 'PeriodStartDate',
    apiEndPoint: null,
    dependsOn: [],
    apiDependsOn: [],
    value: null,
    isDisabled: false,
    isLoading: false,
    option: [],
    showDropdown: true
  },
  {
    key: 'period-end-date',
    attributeName: 'Period End Date',
    external: null,
    internal: 'PeriodEndDate',
    apiEndPoint: null,
    dependsOn: [],
    apiDependsOn: [],
    value: null,
    isDisabled: false,
    isLoading: false,
    option: [],
    showDropdown: true
  },
  {
    key: 'year',
    attributeName: 'Year',
    external: null,
    internal: 'YearBr',
    apiEndPoint: 'year',
    dependsOn: ['Periodicity', 'PeriodEndDate', 'PeriodStartDate'],
    apiDependsOn: ['Periodicity', 'PeriodEndDate', 'PeriodStartDate'],
    value: null,
    isDisabled: false,
    isLoading: false,
    option: [],
    showDropdown: true
  },
  {
    key: 'quarter',
    attributeName: 'Quarter',
    external: null,
    internal: 'QuarterBr',
    apiEndPoint: 'quarter',
    dependsOn: ['YearBr', 'Periodicity', 'PeriodEndDate', 'PeriodStartDate'],
    apiDependsOn: ['YearBr', 'Periodicity', 'PeriodEndDate', 'PeriodStartDate'],
    value: null,
    isDisabled: false,
    isLoading: false,
    option: [],
    showDropdown: true
  },
  {
    key: 'month',
    attributeName: 'Month',
    external: null,
    internal: 'MonthBr',
    apiEndPoint: 'month',
    dependsOn: ['QuarterBr', 'YearBr', 'Periodicity', 'PeriodEndDate', 'PeriodStartDate'],
    apiDependsOn: ['QuarterBr', 'YearBr', 'Periodicity', 'PeriodEndDate', 'PeriodStartDate'],
    value: null,
    isDisabled: false,
    isLoading: false,
    option: [],
    showDropdown: true
  },
  {
    key: 'week',
    attributeName: 'Week',
    external: null,
    internal: 'WeekBr',
    apiEndPoint: 'week',
    dependsOn: ['MonthBr', 'QuarterBr', 'YearBr', 'Periodicity', 'PeriodEndDate', 'PeriodStartDate'],
    apiDependsOn: ['MonthBr', 'QuarterBr', 'YearBr', 'Periodicity', 'PeriodEndDate', 'PeriodStartDate'],
    value: null,
    isDisabled: false,
    isLoading: false,
    option: [],
    showDropdown: true
  },
  {
    key: 'min-period',
    attributeName: 'Min Period Number',
    external: null,
    internal: 'MinPeriod',
    apiEndPoint: 'min-period',
    dependsOn: ['PeriodEndDate', 'PeriodStartDate', 'WeekBr', 'MonthBr', 'QuarterBr', 'YearBr', 'Periodicity'],
    apiDependsOn: ['WeekBr', 'MonthBr', 'QuarterBr', 'YearBr', 'Periodicity', 'PeriodEndDate', 'PeriodStartDate'],
    value: null,
    isDisabled: false,
    isLoading: false,
    option: [],
    showDropdown: true
  },
  {
    key: 'max-period',
    attributeName: 'Max Period Number',
    external: null,
    internal: 'MaxPeriod',
    apiEndPoint: 'max-period',
    dependsOn: ['MinPeriod', 'PeriodEndDate', 'PeriodStartDate', 'WeekBr', 'MonthBr', 'QuarterBr', 'YearBr', 'Periodicity'],
    apiDependsOn: ['MinPeriod', 'WeekBr', 'MonthBr', 'QuarterBr', 'YearBr', 'Periodicity', 'PeriodEndDate', 'PeriodStartDate'],
    value: null,
    isDisabled: false,
    isLoading: false,
    option: [],
    showDropdown: true
  },
  {
    key: 'country-week-start-day',
    attributeName: 'Week Start Day Country',
    external: null,
    internal: 'WeekStartDayCountry',
    apiEndPoint: 'country-week-start-day',
    dependsOn: ['MaxPeriod', 'MinPeriod', 'PeriodEndDate', 'PeriodStartDate', 'WeekBr', 'MonthBr', 'QuarterBr', 'YearBr', 'Periodicity'],
    apiDependsOn: ['MaxPeriod', 'MinPeriod', 'WeekBr', 'MonthBr', 'QuarterBr', 'YearBr', 'Periodicity', 'PeriodEndDate', 'PeriodStartDate'],
    value: null,
    isDisabled: false,
    isLoading: false,
    option: [],
    showDropdown: true
  },
  {
    key: 'month-number',
    attributeName: 'Month Number',
    external: null,
    internal: 'MonthNumber',
    apiEndPoint: 'month-number',
    dependsOn: [
      'PeriodicityIdentifer',
      'WeekStartDayCountry',
      'MaxPeriod',
      'MinPeriod',
      'PeriodEndDate',
      'PeriodStartDate',
      'WeekBr',
      'MonthBr',
      'QuarterBr',
      'YearBr',
      'Periodicity'
    ],
    apiDependsOn: [
      'PeriodicityIdentifer',
      'WeekStartDayCountry',
      'MaxPeriod',
      'MinPeriod',
      'WeekBr',
      'MonthBr',
      'QuarterBr',
      'YearBr',
      'Periodicity',
      'PeriodEndDate',
      'PeriodStartDate'
    ],
    value: null,
    isDisabled: false,
    isLoading: false,
    option: [],
    showDropdown: true
  },
  {
    key: 'period-number',
    attributeName: 'Period Number',
    external: null,
    internal: 'PeriodNumberBr',
    apiEndPoint: 'period-number',
    dependsOn: [
      'MonthNumber',
      'PeriodicityIdentifer',
      'WeekStartDayCountry',
      'MaxPeriod',
      'MinPeriod',
      'PeriodEndDate',
      'PeriodStartDate',
      'WeekBr',
      'MonthBr',
      'QuarterBr',
      'YearBr',
      'Periodicity'
    ],
    apiDependsOn: [
      'MonthNumber',
      'PeriodicityIdentifer',
      'WeekStartDayCountry',
      'MaxPeriod',
      'MinPeriod',
      'WeekBr',
      'MonthBr',
      'QuarterBr',
      'YearBr',
      'Periodicity',
      'PeriodEndDate',
      'PeriodStartDate'
    ],
    value: null,
    isDisabled: false,
    isLoading: false,
    option: [],
    showDropdown: true
  }
];
